import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './InlineLeadNotes.css';

export default function InlineLeadNotes({value,name,onSave,disabled=false}) {
  const [draft,setDraft]=useState(value||'');
  const [busy,setBusy]=useState(false),[error,setError]=useState('');
  const previous=useRef(value||''),lock=useRef(false),input=useRef(null);
  useEffect(()=>{
    const before=previous.current, next=value||'';
    setDraft(current=>current===before?next:current);
    previous.current=next;
  },[value]);
  useLayoutEffect(()=>{
    if(input.current){input.current.style.height='auto';input.current.style.height=Math.max(62,input.current.scrollHeight)+'px';}
  },[draft]);
  const dirty=draft!==(value||'');
  const save=async()=>{
    if(lock.current||disabled||!dirty)return;
    lock.current=true;setBusy(true);setError('');
    try{const saved=await onSave(draft);setDraft(typeof saved==='string'?saved:draft);}catch(failure){setError(failure.message||'Notes could not be saved.');}
    finally{lock.current=false;setBusy(false);}
  };
  return <div className="lead-inline-notes">
    <textarea ref={input} aria-label={`Notes for ${name}`} placeholder="Add notes…" maxLength={10000} rows={2} value={draft} disabled={busy||disabled} onChange={event=>{setDraft(event.target.value);setError('');}}/>
    {dirty&&<div className="lead-inline-note-actions"><button type="button" disabled={busy||disabled} onClick={save}>{busy?'Saving…':'Save notes'}</button><button type="button" disabled={busy||disabled} onClick={()=>{setDraft(value||'');setError('');}}>Cancel</button></div>}
    {error&&<small className="lead-inline-error" role="alert">{error}</small>}
  </div>;
}
